import type {
  ObservationsBatchEditSeverityFieldName,
  ObservationsBatchEditSeverityFieldValue,
} from "./observations-batch-edit-severity.type";
import type { ObservationLite } from "@/entities/observation";

import { useBatchObservationsSeverity } from "@/entities/observations";
import { useBatchEditForm } from "@/modules/batch-edit-form";

import { getObservationsInitialSeverityValue } from "./observations-batch-edit-severity.helper";

const fieldName: ObservationsBatchEditSeverityFieldName = "severity";

export const useObservationsBatchEditSeverity = (
  observations: ObservationLite[]
) => {
  const initialValue = getObservationsInitialSeverityValue(observations);

  const { mutate, isPending, status, error } = useBatchObservationsSeverity();

  const onMutateReady = (value: ObservationsBatchEditSeverityFieldValue) => {
    const ids = observations.map((o) => o.id);
    const severity = value ?? null;
    mutate({ ids, severity });
  };

  const formProps = useBatchEditForm({
    fieldName,
    initialValue,
    onMutateReady,
    status,
    error,
  });

  return {
    ...formProps,
    fieldName,
    initialValue,
    isPending,
  };
};
